const angular = require('angular');

function inputContainerDirective($parse) {
    return {
        restrict: 'E',
        controller: [
            '$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
                const self = this;

                self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);

                self.element = $element;
                self.messagePanel = $element.find('[ng-messages]').first();
                self.setFocused = function (isFocused) {
                    $element.toggleClass('is-focused', !!isFocused);
                };
                self.setHasValue = function (hasValue) {
                    $element.toggleClass('has-value', !!hasValue);
                };
                self.setInvalid = function (isInvalid) {
                    $element.toggleClass('is-invalid', !!isInvalid);

                    // Don't add icon if input is hidden
                    if (!self.input.hasClass('hidden')) {
                        $element.toggleClass('icon-alert_exclamation', !!isInvalid);
                    }

                    // Set aria attribute to input so error message is read out on focus.
                    if (self.messagePanel.length) {
                        if (isInvalid) {
                            let msgId = self.messagePanel.attr('id');
                            if (!msgId) {
                                msgId = self.input.attr('id') + '-messages';
                                self.messagePanel.attr('id', msgId);
                            }

                            self.input.attr('aria-describedby', msgId);
                        } else {
                            self.input.removeAttr('aria-describedby');
                        }
                    }
                };
                $scope.$watch(function () {
                    return self.label && self.input;
                }, function (hasLabelAndInput) {
                    if (hasLabelAndInput && !self.label.attr('for')) {
                        self.label.attr('for', self.input.attr('id'));
                    }
                });
            }
        ]
    };
}

function fakeNgModel() {
    return {
        $fake: true,
        $setViewValue(value) {
            this.$viewValue = value;
            this.$render(value);
            this.$viewChangeListeners.forEach(function (cb) { cb(); });
        },
        $isEmpty(value) {
            return (`${value}`).length === 0;
        },
        $parsers: [],
        $formatters: [],
        $viewChangeListeners: [],
        $render: angular.noop
    };
}

function inputDirective(guid) {
    return {
        restrict: 'E',
        priority: 1,
        require: ['^?wowInputContainer', '?ngModel', '^?form'],
        link(scope, element, attr, ctrls) {
            const containerCtrl = ctrls[0];
            const ngModelCtrl = ctrls[1] || fakeNgModel();
            const ngForm = ctrls[2] || { $submitted: true };
            const isReadonly = angular.isDefined(attr.readonly);
            if (!containerCtrl) {
                return;
            }
            if (containerCtrl.input) {
                throw new Error('<wow-input-container> can only have *one* <input> child element!');
            }
            setTimeout(() => {
                const parent = element && element.parent() && element.parent()[0] && element.parent()[0].tagName === 'WOW-INPUT-CONTAINER';
                if (parent && ctrls && ctrls[1] && ctrls[1].$viewValue) {
                    element.parent()[0].classList.add('has-value');
                }
            });
            containerCtrl.input = element;

            element.addClass('wowInput');
            element.addClass('input--clear');

            if (!element.attr('id')) {
                element.attr('id', `input_${guid()}`);
            }

            function ngModelPipelineCheckValue(arg) {
                containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
                return arg;
            }

            function inputCheckValue() {
                // An
                // input's value counts if its length > 0,
                // or if the input's validity state says it has bad input (eg string in a number input)
                if (ngForm) {
                    if (element[0].name && ngForm[element[0].name]) {
                        ngForm[element[0].name].$setValidity('serverError', true);
                    }
                }
                containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
            }

            const isErrorGetter = containerCtrl.isErrorGetter || function () {
                return ngModelCtrl.$invalid && ngForm.$submitted;
            };
            scope.$watch(isErrorGetter, function (isInvalid) {
                containerCtrl.setInvalid(isInvalid);
                element.attr('aria-invalid', isInvalid);
            });

            ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
            ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);

            element.on('input', inputCheckValue);

            if (!isReadonly) {
                element
                    .on('focus', function () {
                        containerCtrl.setFocused(true);
                    })
                    .on('blur', function () {
                        containerCtrl.setFocused(false);
                        inputCheckValue();
                    });
            }

            scope.$on('$destroy', function () {
                containerCtrl.setFocused(false);
                containerCtrl.setHasValue(false);
                containerCtrl.input = null;
            });
        }
    };
}

function labelDirective() {
    return {
        restrict: 'E',
        require: '^?wowInputContainer',
        link(scope, element, attr, containerCtrl) {
            if (!containerCtrl) {
                return;
            }

            containerCtrl.label = element;
            element.addClass('wowLabel');

            scope.$on('$destroy', function () {
                containerCtrl.label = null;
            });
        }
    };
}

function placeholderDirective() {
    return {
        restrict: 'A',
        require: '^^?wowInputContainer',
        link(scope, element, attr, inputContainer) {
            if (!inputContainer) {
                return;
            }
            const placeholderText = attr.placeholder;
            element.removeAttr('placeholder');

            inputContainer.element.find('input').after(`<div class="wowPlaceholder">${placeholderText}</div>`);
        }
    };
}

module.exports = {
    inputContainer: inputContainerDirective,
    input: inputDirective,
    label: labelDirective,
    placeholder: placeholderDirective
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/input/input-directive.js
 **/